<template>
    <l-layout :layout="['xs12']">
      <l-data-table
        ref="parkList"
      :headers="header"
      :get-data-func="getParkList"
      @click:row="getDetails($event.item)"
      clickable
      title-text="园区列表">
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="deleteParkConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除园区</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addPark"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </l-layout>
</template>

<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
export default {
  name: 'parkList',
  components: {LDataTable},
  data () {
    return {
      header: [
        {text: '园区名称', value: 'name', align: 'left'},
        {text: '园区等级', value: 'parkLevel', align: 'left'},
        {text: '创建人', value: 'creator', align: 'left', sortable: false},
        {text: '', value: '', align: 'left', sortable: false}
      ]
    }
  },
  methods: {
    async getParkList ({pagination, sortStack, filterItems, search}) {
      let res = await this.$store.dispatch('park/getParkList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}})
      return res
    },
    addPark () {
      this.$router.push({name: 'newPark'})
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'parkDetailsBox', query: {id: item.id}})
      }
    },
    async deleteParkConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该园区？',
        text: '园区名称:' + item.name
      })
      if (res) {
        try {
          await this.deletePark(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deletePark (item) {
      let ids = []
      ids.push(item.id)
      let res = await this.$store.dispatch('park/deletePark', ids)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.parkList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
  },
  activated(){
    this.$refs.parkList.refresh()
  }
}
</script>

<style scoped>

</style>
